export interface IAlertAction {
  label: string
  handler: () => void | Promise<void>
}

export interface IAlert {
  type: AlertTypes
  title: string
  body: string
  lifetime?: number
  action?: IAlertAction
}

export enum AlertTypes {
  NEUTRAL = 1,
  SUCCESS = 2,
  WARNING = 3,
  ERROR = 4
}
